/**
 * Format points for display. Backend stores points in cents (e.g. 253 for odd 2.53).
 * Legacy data may be small integers (1, 3, 10); treat as whole numbers.
 */

/**
 * Format points value for display (e.g. "+2.53", "0.00", "—").
 * When value >= 100, treat as cents and show as decimal; otherwise legacy integer.
 */
export function formatPointsFromCents(
  cents: number | null | undefined
): string {
  if (cents === null || cents === undefined) return '—';
  if (cents >= 100) {
    const decimal = (cents / 100).toFixed(2);
    return cents > 0 ? `+${decimal}` : decimal;
  }
  return cents > 0 ? `+${cents}` : String(cents);
}

/**
 * Format points for display without leading "+" (points cannot go negative).
 */
export function formatPointsDisplay(cents: number | null | undefined): string {
  const s = formatPointsFromCents(cents);
  return s === '—' ? s : s.replace(/^\+/, '');
}
